import React from 'react';

function Contact() {
  return <div id="vue2AppContainer" />;
}

export default Contact;
